import { Injectable } from '@angular/core';
import { MongoStoredObject } from '@app/types/mongo-stored-object';
import {
  EIntegrationProvider,
  IIntegration
} from '@backend/models/types/integration';
import { ITenantFeatures } from '@backend/models/types/tenant';

export type TenantWithAttendance = {
  features?: Partial<Pick<ITenantFeatures, 'attendanceApproval'>>;
};

export type IntegrationsLike =
  | MongoStoredObject<IIntegration[]>
  | IIntegration[]
  | null
  | undefined;

@Injectable({ providedIn: 'root' })
export class AttendanceApprovalService {
  public hasActiveHomebaseIntegration(integrations: IntegrationsLike): boolean {
    const integrationsArray = Array.isArray(integrations)
      ? integrations
      : ((integrations ?? []) as IIntegration[]);

    return integrationsArray.some(
      (integration) =>
        integration.provider === EIntegrationProvider.HOMEBASE &&
        !integration.isInitializing
    );
  }

  public isAttendanceApprovalEnabled(
    tenant: TenantWithAttendance,
    integrations: IntegrationsLike
  ): boolean {
    return (
      !!tenant?.features?.attendanceApproval &&
      this.hasActiveHomebaseIntegration(integrations)
    );
  }
}
